export class MarketplaceQuote {
  price: number;
  pax: number;
  aircraftId: number;
  category: string;
}
